export default "__VITE_ASSET__DzP$kMKO__"